import React, { createContext, useContext, useState, useReducer } from 'react';

/**
 * PortalContext
 * 
 * Shared portal data:
 * - categories
 * - officers
 * - shifts
 * - ranks
 * - patrols (active patrol requests)
 * - recentChecks (from polling)
 */
const PortalContext = createContext();

const initialState = {
  categories: window.LEP?.categories || [],
  officers: window.LEP?.officers || [],
  shifts: window.LEP?.shifts || [],
  ranks: window.LEP?.ranks || [],
  patrols: [],
  recentChecks: [],
  generalSettings: {
    warning_message: window.LEP?.warning_message || '',
    officer_can_view_dept: !!window.LEP?.officer_can_view_dept,
    legend_trigger_len: window.LEP?.legend_trigger_len ?? 12,
    portal_slug: window.LEP?.portal_slug || 'law-enforcement-portal',
  },
  loading: false,
  error: null,
};

function portalReducer(state, action) {
  switch (action.type) {
    case 'SET_CATEGORIES':
      return { ...state, categories: action.payload };
    case 'SET_OFFICERS':
      return { ...state, officers: action.payload };
    case 'SET_SHIFTS':
      return { ...state, shifts: action.payload };
    case 'SET_RANKS':
      return { ...state, ranks: action.payload };
    case 'SET_PATROLS':
      return { ...state, patrols: action.payload };
    case 'SET_RECENT_CHECKS':
      return { ...state, recentChecks: action.payload };
    case 'SET_GENERAL_SETTINGS':
      return { ...state, generalSettings: { ...state.generalSettings, ...action.payload } };
    case 'SET_LOADING':
      return { ...state, loading: action.payload };
    case 'SET_ERROR':
      return { ...state, error: action.payload };
    default:
      return state;
  }
}

export function PortalProvider({ children }) {
  const [state, dispatch] = useReducer(portalReducer, initialState);

  return (
    <PortalContext.Provider value={{ state, dispatch }}>
      {children}
    </PortalContext.Provider>
  );
}

export function usePortal() {
  const context = useContext(PortalContext);
  if (!context) {
    throw new Error('usePortal must be used within PortalProvider');
  }
  return context;
}
